import { ChatWithUsIcon, FAQIcon, GreyStrokeInfoIcon } from 'assets/icons';
import React, { FC } from 'react';
import { VoidFn } from 'types/baseTypes';

interface HelpMenuProps {
  onChat: VoidFn;
  onFAQ: VoidFn;
  onHelpSupport: VoidFn;
}

const HelpMenu: FC<HelpMenuProps> = ({ onChat, onFAQ, onHelpSupport }) => {
  return (
    <div className="flex flex-col space-y-6 text-sbase font-normal text-primaryText">
      <div
        onClick={onFAQ}
        className="flex cursor-pointer flex-row items-center gap-4"
        role="button"
        tabIndex={0}
        onKeyDown={e => e.key === 'Enter' && onFAQ()}
        aria-label="Open FAQs">
        <FAQIcon className="shrink-0" />
        <div>FAQs</div>
      </div>
      <div
        onClick={onChat}
        className="flex cursor-pointer flex-row items-center gap-4"
        role="button"
        tabIndex={0}
        onKeyDown={e => e.key === 'Enter' && onChat()}
        aria-label="Chat with us">
        <ChatWithUsIcon className="shrink-0" />
        <div>Chat with us</div>
      </div>
      <div
        onClick={onHelpSupport}
        className="flex cursor-pointer flex-row items-center gap-4"
        role="button"
        tabIndex={0}
        onKeyDown={e => e.key === 'Enter' && onHelpSupport()}
        aria-label="Open Help and Support">
        <GreyStrokeInfoIcon className="path-fill-current shrink-0 text-accentText" />
        <div>Help & Support</div>
      </div>
    </div>
  );
};

export default HelpMenu;
